import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Col, Form, Row, Select, Input, DatePicker, Checkbox } from "antd";
import PropTypes from "prop-types";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import FromInput from "../../../../../../components/user/from/Input";
import moment from "moment";

class InVacationInformation extends Component {
  dateFormatNumber(values) {
    const { form } = this.props;
    let valueReturn = form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  }

  render() {
    const { rawData, form } = this.props;
    const studyLeaveDetails = rawData?.studyLeaveDetails[0] || {};

    return (
      <Row gutter={16}>
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">ข้อมูลการลา</strong>
        </Col>
        <Col xs={24} md={12} className="pt-2 mb-2">
          <Form.Item label={"ระดับการศึกษา"} className="mb-0">
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={studyLeaveDetails?.studyLeaveDegree || "-"}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-2 mb-2">
          <Form.Item label={"หลักสูตร"} className="mb-0">
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={studyLeaveDetails?.studyLeaveCourse || "-"}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"วุฒิการศึกษา"} className="mb-0">
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={studyLeaveDetails?.studyLeaveEducational || "-"}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"สาขาวิชา"} className="mb-0">
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={studyLeaveDetails?.studyLeaveMajor || "-"}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"ประเทศ"} className="mb-0">
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={studyLeaveDetails?.studyLeaveCountry || "-"}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <FromInput
            disabled={true}
            value={
              studyLeaveDetails?.studyLeaveCountry.includes("ไทย")
                ? "ในประเทศ"
                : "ต่างประเทศ"
            }
            required={false}
            name={"studyLeaveCountry2"}
            label="ในประเทศ หรือ ต่างประเทศ"
            mode={"text"}
          />
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"สถาบันการศึกษา"} className="mb-0">
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={studyLeaveDetails?.studyLeaveAcademy || "-"}
            ></Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <FromInput
            disabled={true}
            value={studyLeaveDetails?.studyLeaveStrategyYear || "-"}
            required={false}
            name={"studyLeaveStrategyYear"}
            label="ปีการศึกษา"
            mode={"text"}
          />
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"วันที่เริ่มต้นลาศึกษา"} className="mb-0">
            {form.getFieldDecorator("studyLeaveStartDate", {
              initialValue: moment(
                studyLeaveDetails?.studyLeaveStartDate || "-"
              ),
            })(
              <DatePicker
                format={this.dateFormatNumber("studyLeaveStartDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"วันที่สิ้นสุดการศึกษา"} className="mb-0">
            {form.getFieldDecorator("studyLeaveEndDate", {
              initialValue: moment(studyLeaveDetails?.studyLeaveEndDate || "-"),
            })(
              <DatePicker
                format={this.dateFormatNumber("studyLeaveEndDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"ระยะเวลาหลักสูตร"} className="mb-0">
            <Form
              labelCol={{ offset: 0, span: "100px", push: 1 }}
              wrapperCol={{
                offset: 0,
                span: 18,
                xl: { span: 14 },
                xxl: { span: 17 },
              }}
              colon={false}
            >
              <Row gutter={4} type="flex" justify="left" align="top">
                <Col span={24} xl={8}>
                  <Form.Item label="ปี" className="m-0">
                    {form.getFieldDecorator("studyLeaveDurationYear", {
                      initialValue:
                        studyLeaveDetails?.studyLeaveDurationYear || "-",
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>
                <Col span={24} xl={8}>
                  <Form.Item label="เดือน" className="m-0">
                    {form.getFieldDecorator("studyLeaveDurationMonth", {
                      initialValue:
                        studyLeaveDetails?.studyLeaveDurationMonth || "-",
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>
                <Col span={24} xl={8}>
                  <Form.Item label="วัน" className="m-0">
                    {form.getFieldDecorator("studyLeaveDurationDay", {
                      initialValue:
                        studyLeaveDetails?.studyLeaveDurationDay || "-",
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"จำนวนวันที่ลาศึกษา (วัน)"} className="mb-0">
            {form.getFieldDecorator("studyLeaveDurationDay", {
              initialValue: studyLeaveDetails?.studyLeaveDuration || "-",
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"ลักษณะการลา"} className="mb-0">
            {
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={studyLeaveDetails?.studyLeaveType}
              ></Select>
            }
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item
            label={"ต้องตีพิมพ์งานวิจัย"}
            valuePropName={"checked"}
            className="mb-0"
          >
            <Checkbox
              checked={studyLeaveDetails?.isPublishJournal}
              value={studyLeaveDetails?.isPublishJournal}
              disabled={true}
            ></Checkbox>
          </Form.Item>
        </Col>
      </Row>
    );
  }
}

InVacationInformation.defaultProps = {
  autoFocus: false,
};

InVacationInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedInVacationInformation = Form.create()(InVacationInformation);

export default withApollo(WrappedInVacationInformation);
